/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseAccountFormComponent } from '../base-account-form.component';
import { IFieldInfo } from '../shared/interface/IFieldInfo';
import { StatesService } from './../../../services/states.service';
import { CityService } from './../../../services/city.service';
import { PoComboFilterMode } from '@po-ui/ng-components';

@Component({
  selector: 'tgv-address',
  standalone: false,
  templateUrl: './address.component.html'
})
export class AddressComponent extends BaseAccountFormComponent implements OnInit {
  @Input() isOnline: boolean;
  @Input() isDisableField = 'false';
  zipCodeInfo: IFieldInfo;
  filterMode = PoComboFilterMode.contains;

  constructor(override injector: Injector, protected statesService: StatesService, protected cityService: CityService) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.onInitZipCode();
    this.onInitState();
  }

  getNameOfFields(): string[] {
    return ['zipcode', 'uf', 'citycode', 'address', 'neighborhood', 'addresscomplement'];
  }

  onInitZipCode(): void {
    this.zipCodeInfo = this.accountService.getZipCodeMaskByCountry(this.cPaisLoc);
  }

  onInitState(): void {
    this.cityService.setState(this.form?.get('uf')?.value);
  }

  onChangeState(state = ''): void {
    this.cityService.setState(state);
    if (this.form?.get('state')?.value !== '' && state !== this.form?.get('state')?.value) {
      this.form.get('citycode')?.setValue('');
    }
  }

  isBRA(): boolean {
    return this.cPaisLoc === 'BRA';
  }
}
